/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="55" height="51" viewBox="0 0 55 51" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <defs>
    <mask id="a" x="0" y="0" width="54.57" height="50.28" maskUnits="userSpaceOnUse">
      <g transform="translate(-0.25 -0.81)">
        <polygon points="0.25 0.81 54.82 0.81 54.82 51.09 0.25 51.09 0.25 0.81" style={{fill: "#fff",fillRule: "evenodd"}}/>
      </g>
    </mask>
  </defs>
  <path d="M24.78,13h4.81V9H24.78Zm5,16.14h2.6V31.9H22.72V29.14h2.61V18.68H22.72V15.84h7Z" transform="translate(-0.25 -0.81)" style={{fill: "#ffb81c",fillRule: "evenodd"}}/><g style={{mask: "url(#a)"}}>
      <path d="M6.84,2.83A4.58,4.58,0,0,0,2.27,7.4V33.48a4.52,4.52,0,0,0,4.57,4.57H36a1,1,0,0,1,.72.3l9.19,9.27V39.06a1,1,0,0,1,1-1h1.28a4.58,4.58,0,0,0,4.57-4.57V7.4a4.58,4.58,0,0,0-4.57-4.57ZM47,51.09a1,1,0,0,1-.71-.3L35.61,40.07H6.84A6.52,6.52,0,0,1,.25,33.48V7.4A6.6,6.6,0,0,1,6.84.81H48.23A6.6,6.6,0,0,1,54.82,7.4V33.48a6.6,6.6,0,0,1-6.59,6.59H48v10a1,1,0,0,1-.63.93,1,1,0,0,1-.39.08Z" transform="translate(-0.25 -0.81)" style={{fill: "#0e497b",fillRule: "evenodd"}}/>
    </g>
</svg>

    )
  }
}

Icon.displayName = 'InformationWordBubbleIcon'

export default Icon
